import { Pipe, PipeTransform } from '@angular/core';
import { TravelerNamesInner } from 'src/sdk-servicing';

/**
 * 搭乗者名を結合するパイプ
 */
@Pipe({
  name: 'passengerName',
})
export class PassengerNamePipe implements PipeTransform {
  transform(name: TravelerNamesInner | undefined): string {
    if (!name) {
      return '';
    }
    // nameの中でundefinedの要素を省くことで登録されていないものを出力しないようにする
    const displayElements = [name.title, name.firstName, name.lastName].filter((element) => !!element);
    return displayElements.join(' ');
  }
}
